import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import baseUrl from "./BaseUrl";

function ForceChangePassword() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [msg, setMsg] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [isMatching, setIsMatching] = useState(true);
    const [validations, setValidations] = useState({
        minLength: false,
        hasUpperCase: false,
        hasLowerCase: false,
        hasSpecialChar: false,
        hasNumber: false
    });
    const [validationErrors, setValidationErrors] = useState({
        password: false,
        confirmPassword: false,
    });
    const navigate = useNavigate();
    const formRef = useRef(null);

    // Only reachable with a verified session that still has a pending password change
    useEffect(() => {
        const checkSession = async () => {
            try {
                const response = await axios.get(`${baseUrl}/mfa-token`);
                if (response.data.is_mfa_verify != 1) {
                    navigate("/");
                } else if (response.data.force_password_change != 1) {
                    navigate("/dashboard");
                }
            } catch (error) {
                navigate("/");
            }
        };
        checkSession();
    }, []);

    const handlePasswordChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        setValidations({
            minLength: newPassword.length >= 12,
            hasUpperCase: /[A-Z]/.test(newPassword),
            hasLowerCase: /[a-z]/.test(newPassword),
            hasSpecialChar: /[!@#$%^&+=]/.test(newPassword),
            hasNumber: /[0-9]/.test(newPassword),
        });
        setIsMatching(confirmPassword === newPassword);
    };

    const handleConfirmPasswordChange = (e) => {
        const newConfirmPassword = e.target.value;
        setConfirmPassword(newConfirmPassword);
        setIsMatching(newConfirmPassword === password);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newValidationErrors = {
            password: password === '',
            confirmPassword: confirmPassword === '',
        };
        setValidationErrors(newValidationErrors);

        const checkFiled = Object.values(newValidationErrors).some((error) => error);
        const hasErrors = Object.values(validations).filter((value) => value === true).length;

        if (!checkFiled && hasErrors == 5 && isMatching) {
            try {
                await axios.post(`${baseUrl}/force-change-password`, {
                    password: password
                });
                setIsSuccess(true);
                setMsg('Password updated successfully. Redirecting...');
                setTimeout(() => navigate('/dashboard'), 2000);
            } catch (error) {
                setIsSuccess(false);
                setMsg(error.response?.data?.error || 'Error updating password.');
            }
        }
    };

    return (
        <section className="ragister-login loginpage">
            <div className="row d-flex align-items-center">
                <div className="col-md-5 left-box">
                    <div className="inner-slider"></div>
                </div>
                <div className="col-md-7 right-box">
                    <div className="form-body">
                        <div className="left-logo">
                            <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="" />
                        </div>
                        <form onSubmit={handleSubmit} ref={formRef} className="form-box">
                            <p className="error error-message">Your password must be updated before continuing.</p>
                            {msg && <p className={`has-text-centered ${isSuccess ? 'success' : 'error'}`}>{msg}</p>}
                            <div className="field mt-5">
                                <label className="label">New Password</label>
                                <div className="controls">
                                    <input type="password" className="input" value={password} onChange={handlePasswordChange} />
                                    {validationErrors.password && <div className="error error-message">Please enter password.</div>}
                                </div>
                            </div>
                            <div className="field mt-5">
                                <label className="label">Confirm Password</label>
                                <div className="controls">
                                    <input type="password" className="input" value={confirmPassword} onChange={handleConfirmPasswordChange} />
                                    {validationErrors.confirmPassword && <div className="error error-message">Please enter confirm password.</div>}
                                </div>
                            </div>
                            <div>
                                <ul>
                                    <li className={validations.minLength ? 'valid' : 'invalid'}>Minimum 12 characters</li>
                                    <li className={validations.hasUpperCase ? 'valid' : 'invalid'}>At least one uppercase letter</li>
                                    <li className={validations.hasLowerCase ? 'valid' : 'invalid'}>At least one lowercase letter</li>
                                    <li className={validations.hasSpecialChar ? 'valid' : 'invalid'}>At least one special character (e.g., @, #, $)</li>
                                    <li className={validations.hasNumber ? 'valid' : 'invalid'}>At least one number</li>
                                    {!isMatching && <li className="error-message">Passwords do not match.</li>}
                                </ul>
                            </div>
                            <div className="field mt-5 logindiv">
                                <input type="submit" value="Update Password" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ForceChangePassword;
